import { API_URLS, customAxios } from "../config";

export const getAccountSetting = (query = "") =>
  customAxios
    .get(API_URLS.getAccountSetting + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveUploadAccLogo = (payload) =>
  customAxios
    .post(API_URLS.saveUploadAccLogo, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveUploadAccDocument = (payload, query) =>
  customAxios
    .post(API_URLS.saveUploadAccDocument + "/" + query, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const deleteAccountingDocument = (payload) =>
  customAxios
    .post(API_URLS.deleteAccountingDocument, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const updateAccPeriodStatus = (payload) =>
  customAxios
    .post(API_URLS.updateAccPeriodStatus, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveScheduleCompanyName = (payload) =>
  customAxios
    .post(API_URLS.saveScheduleCompanyName, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const getCompanySetting = (merchantId = "") =>
  customAxios
    .get(API_URLS.getCompanySetting + "/" + merchantId)
    .then((res) => res?.data)
    .catch((error) => error);
export const getScheduleCompanyName = (merchantId = "") =>
  customAxios
    .get(API_URLS.getScheduleCompanyName + "/" + merchantId, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const getCodeList = (query = "") =>
  customAxios
    .get(API_URLS.getCodeList + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveCodeData = (query = "") =>
  customAxios
    .get(API_URLS.saveCodeData + query, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const saveAccountManagementData = (payload) =>
  customAxios
    .post(API_URLS.saveAccountManagementData, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updateAccountAdminData = (payload) =>
  customAxios
    .post(API_URLS.updateAccountAdminData, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updatePlanCostData = (payload) =>
  customAxios
    .post(API_URLS.updatePlanCostData, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updatePlanTopupData = (payload) =>
  customAxios
    .post(API_URLS.updatePlanTopupData, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updatePosCountData = (payload) =>
  customAxios
    .post(API_URLS.updatePosCountData, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const savePaymentInfoData = (payload) =>
  customAxios
    .post(API_URLS.savePaymentInfoData, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const getOwnerSubAccData = (query = "") =>
  customAxios
    .get(API_URLS.getOwnerSubAccData + query, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const deleteCodeDetails = (payload) =>
  customAxios
    .post(API_URLS.deleteCodeDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const cancelAccountData = (payload) =>
  customAxios
    .post(API_URLS.cancelAccountData, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const getAccountManagement = (query = "") =>
  customAxios
    .get(API_URLS.getAccountManagement + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const getInvoiceListData = (payload) =>
  customAxios
    .post(API_URLS.getInvoiceListData, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getInvoiceDetailsData = (query = "") =>
  customAxios
    .get(API_URLS.getInvoiceDetailsData + query, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);

// user-management
export const getUserManagementData = (query = "") =>
  customAxios
    .get(API_URLS.getUserManagementData + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const getMerchantUserListData = (payload) =>
  customAxios
    .post(API_URLS.getMerchantUserListData, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getPermissionGroupListData = (payload) =>
  customAxios
    .post(API_URLS.getPermissionGroupListData, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const updateUserManageData = (payload) =>
  customAxios
    .post(API_URLS.updateUserManageData, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const addLinkedEmployeeData = (payload) =>
  customAxios
    .post(API_URLS.addLinkedEmployeeData, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);

// cluster-settings
export const getClusterSetting = (query = "") =>
  customAxios
    .get(API_URLS.getClusterSetting + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const addClusterDetails = (query = "") =>
  customAxios
    .get(API_URLS.addClusterDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveClusterdetails = (payload) =>
  customAxios
    .post(API_URLS.addClusterDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const editClusterdetails = (payload) =>
  customAxios
    .post(API_URLS.editClusterDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const getClusterModules = (payload) =>
  customAxios
    .post(API_URLS.getClusterModules, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const addClusterAccess = (payload) =>
  customAxios
    .post(API_URLS.addClusterAccess, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const editClusterAccess = (payload) =>
  customAxios
    .post(API_URLS.editClusterAccess, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const addClusterStore = (payload) =>
  customAxios
    .post(API_URLS.addClusterStore, payload)
    .then((res) => res?.data)
    .catch((error) => error);

/* finance - settings */
// general settings
export const getFinanceGeneralDetails = (query = "") =>
  customAxios
    .get(API_URLS.getFinanceGeneralDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveFinanceGeneralDetails = (payload) =>
  customAxios
    .post(API_URLS.getFinanceGeneralDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const savePaymentMethodDetails = (payload) =>
  customAxios
    .post(API_URLS.savePaymentMethodDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updatePaymentMethodDetails = (payload) =>
  customAxios
    .post(API_URLS.updatePaymentMethodDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);

export const saveServicePeriodDetails = (payload) =>
  customAxios
    .post(API_URLS.saveServicePeriodDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updateServicePeriodDetails = (payload) =>
  customAxios
    .post(API_URLS.updateServicePeriodDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);

export const saveSaleTypeDetails = (payload) =>
  customAxios
    .post(API_URLS.saveSaleTypeDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);

export const updateSaleTypeDetails = (payload) =>
  customAxios
    .post(API_URLS.updateSaleTypeDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);

export const deleteServicePeriodDetails = (payload) =>
  customAxios
    .post(API_URLS.deleteServicePeriodDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deleteSaleTypeDetails = (payload) =>
  customAxios
    .post(API_URLS.deleteSaleTypeDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deletePaymentMethodDetails = (payload) =>
  customAxios
    .post(API_URLS.deletePaymentMethodDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const udpatePaymentMethodOrder = (payload) =>
  customAxios
    .post(API_URLS.udpatePaymentMethodOrder, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getFinanceSaleDetails = (query = "") =>
  customAxios
    .get(API_URLS.getFinanceSaleDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const getOrderSettings = (payload) =>
  customAxios
    .get(API_URLS.orderSettings)
    .then((res) => res?.data)
    .catch((err) => err);

export const getGroupAccDetails = (query) =>
  customAxios
    .get(API_URLS.getGroupAccDetails + query)
    .then((res) => res?.data)
    .catch((err) => err);

export const postOrderSettings = (payload) =>
  customAxios
    .post(API_URLS.orderSettings, payload)
    .then((res) => res?.data)
    .catch((err) => {
      console.log("settingDataPost", err);
      return err;
    });

export const saveSaleGroupDetails = (payload) =>
  customAxios
    .post(API_URLS.saveSaleGroupDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const deleteSaleGroupDetails = (payload) =>
  customAxios
    .post(API_URLS.deleteSaleGroupDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const saveChannelDetails = (payload) =>
  customAxios
    .post(API_URLS.saveChannelDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updateChannelDetails = (payload) =>
  customAxios
    .post(API_URLS.updateChannelDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const deleteChannelDetails = (payload) =>
  customAxios
    .post(API_URLS.deleteChannelDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);

export const getPublicHolidayDetails = (query = "") =>
  customAxios
    .get(API_URLS.getPublicHolidayDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const savePublicHolidayDetails = (payload) =>
  customAxios
    .post(API_URLS.savePublicHolidayDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);

export const deletePublicHolidayDetails = (payload) =>
  customAxios
    .post(API_URLS.deletePublicHolidayDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);

export const updateMatrixSetting = (payload) =>
  customAxios
    .post(API_URLS.updateMatrixSetting, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getMasterSettingDetails = (query = "") =>
  customAxios
    .get(API_URLS.getMasterSettingDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const savePmMasterSettingDetails = (payload) =>
  customAxios
    .post(API_URLS.savePmMasterSettingDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updatePmMasterSettingDetails = (payload) =>
  customAxios
    .post(API_URLS.updatePmMasterSettingDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updatePmMasterSettingStatusDetails = (payload) =>
  customAxios
    .post(API_URLS.updatePmMasterSettingStatusDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const refreshPmMasterSettingDetails = (payload) =>
  customAxios
    .post(API_URLS.refreshPmMasterSettingDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveSalesMasterSettingDetails = (payload) =>
  customAxios
    .post(API_URLS.saveSalesMasterSettingDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updateSalesMasterSettingDetails = (payload) =>
  customAxios
    .post(API_URLS.updateSalesMasterSettingDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updateSalesMasterSettingStatusDetails = (payload) =>
  customAxios
    .post(API_URLS.updateSalesMasterSettingStatusDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const refreshSalesMasterSettingDetails = (payload) =>
  customAxios
    .post(API_URLS.refreshSalesMasterSettingDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveServicePeriodsMasterSettingDetails = (payload) =>
  customAxios
    .post(API_URLS.saveServicePeriodsMasterSettingDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updateServicePeriodsMasterSettingDetails = (payload) =>
  customAxios
    .post(API_URLS.updateServicePeriodsMasterSettingDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updateServicePeriodsMasterSettingStatusDetails = (payload) =>
  customAxios
    .post(API_URLS.updateServicePeriodsMasterSettingStatusDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const refreshServicePeriodsMasterSettingDetails = (payload) =>
  customAxios
    .post(API_URLS.refreshServicePeriodsMasterSettingDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveChannelsMasterSettingDetails = (payload) =>
  customAxios
    .post(API_URLS.saveChannelsMasterSettingDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updateChannelsMasterSettingDetails = (payload) =>
  customAxios
    .post(API_URLS.updateChannelsMasterSettingDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updateChannelsMasterSettingStatusDetails = (payload) =>
  customAxios
    .post(API_URLS.updateChannelsMasterSettingStatusDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const refreshChannelsMasterSettingDetails = (payload) =>
  customAxios
    .post(API_URLS.refreshChannelsMasterSettingDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
// chart of accounts
export const getFinanceChartOfAccSettingDetails = (query = "") =>
  customAxios
    .get(API_URLS.getFinanceChartOfAccSettingDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const getFinanceAccDetails = (query = "") =>
  customAxios
    .get(API_URLS.getFinanceAccDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const downloadAllFinanceAccDetail = (query = "") =>
  customAxios
    .get(API_URLS.downloadAllFinanceAccDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const addFinanceAccDetail = (query = "") =>
  customAxios
    .get(API_URLS.addFinanceAccDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const addFinanceSubAccDetail = (query = "") =>
  customAxios
    .get(API_URLS.addFinanceSubAccDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveFinanceSubAccDetail = (query = "", payload) =>
  customAxios
    .post(API_URLS.addFinanceSubAccDetail + query, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveEditSubAccDetail = (query = "", payload) =>
  customAxios
    .post(API_URLS.getUpdateFinanceSubAccDetail + query, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveAccTransaction = (query = "", payload) =>
  customAxios
    .post(API_URLS.saveAccTransaction + query, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getUpdateFinanceSubAccDetail = (query = "") =>
  customAxios
    .get(API_URLS.getUpdateFinanceSubAccDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const getSubAccTransactionsDetails = (query = "", payload) =>
  customAxios
    .post(API_URLS.getSubAccTransactionsDetails + query, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getAddTransSubAccDetail = (query = "") =>
  customAxios
    .get(API_URLS.getAddTransSubAccDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const getDebitCreditAccDetails = (payload) =>
  customAxios
    .post(API_URLS.getDebitCreditAccDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getForecastSettingsDetail = (query = "") =>
  customAxios
    .get(API_URLS.getForecastSettingsDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const getForecastRulesDetail = (query = "") =>
  customAxios
    .get(API_URLS.getForecastRulesDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const getApplicableQuarterDetail = (payload) =>
  customAxios
    .post(API_URLS.getApplicableQuarterDetail, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveForecastSettingsDetail = (payload) =>
  customAxios
    .post(API_URLS.saveForecastSettingsDetail, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const editFinanceRuleDetail = (query = "") =>
  customAxios
    .get(API_URLS.editFinanceRuleDetail + query, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const updateFinanceRuleDetail = (query = "", payload) =>
  customAxios
    .post(API_URLS.editFinanceRuleDetail + query, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);

export const getOrderTransferData = () =>
  customAxios
    .get(API_URLS.orderTransferData)
    .then((res) => res?.data)
    .catch((error) => error);

export const getSecondAccounts = (payload) =>
  customAxios
    .post(API_URLS.secondAccountData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const addTransferAccount = (payload) =>
  customAxios
    .post(API_URLS.addTransferAccount, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getTransferAccountEditDetails = (query) =>
  customAxios
    .get(API_URLS.transferAccountEditDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const editTransferAccount = (payload) =>
  customAxios
    .post(API_URLS.editTransferAccount + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postOrderTransferData = (payload) =>
  customAxios
    .post(API_URLS.postOrderTransferData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const updateTransferAccountStatus = (payload) =>
  customAxios
    .post(API_URLS.updateTransferAccountStatus)
    .then((res) => res?.data)
    .catch((error) => error);

// onLife
export const getOnlifeData = (payload) =>
  customAxios
    .get(API_URLS.getOnlifeData)
    .then((res) => res?.data)
    .catch((err) => err);

export const postMerchantOnlifeData = (payload) =>
  customAxios
    .post(API_URLS.postMerchantOnlifeData, payload)
    .then((res) => res?.data)
    .catch((err) => err);

export const postCompetitorOnlifeData = (payload) =>
  customAxios
    .post(API_URLS.postCompetitorOnlifeData, payload)
    .then((res) => res?.data)
    .catch((err) => err);

export const deleteCompetitorOnlifeData = (payload) =>
  customAxios
    .post(API_URLS.deleteCompetitorOnlifeData, payload)
    .then((res) => res?.data)
    .catch((err) => err);
export const getReconsileDetail = (query) =>
  customAxios
    .get(API_URLS.getReconsileDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveReconsileDetail = (payload) =>
  customAxios
    .post(API_URLS.saveReconsileDetail, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const deleteReconsileDetail = (payload) =>
  customAxios
    .post(API_URLS.deleteReconsileDetail, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const getReconsileUploadDetail = (query) =>
  customAxios
    .get(API_URLS.getReconsileUploadDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveReconsileUploadDetail = (query, payload) =>
  customAxios
    .post(API_URLS.getReconsileUploadDetail + query, payload)
    .then((res) => res?.data)
    .catch((error) => error);

// pos master --> pos master
export const getPosMasterData = (payload) =>
  customAxios
    .get(API_URLS.getPosMasterData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postAddPosMasterFormData = (payload) =>
  customAxios
    .post(API_URLS.postAddPosMasterFormData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postPosMasterActiveStatus = (payload) =>
  customAxios
    .post(API_URLS.postPosMasterActiveStatus, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPosMasterFormOptions = (payload) =>
  customAxios
    .get(API_URLS.getPosMasterFormOptions, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEditPosMasterFormData = (query) =>
  customAxios
    .get(API_URLS.getEditPosMasterFormData + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const postEditPosMasterFormData = (payload) =>
  customAxios
    .post(API_URLS.postEditPosMasterFormData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postPosIntegrationSetting = (payload) =>
  customAxios
    .post(API_URLS.postPosIntegrationSetting, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getApplicableModule = (query) =>
  customAxios
    .get(API_URLS.getApplicableModule + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const getFrequency = (query) =>
  customAxios
    .get(API_URLS.getFrequency + query)
    .then((res) => res?.data)
    .catch((error) => error);

// layout master
export const getRoomsLayoutData = (payload) =>
  customAxios
    .get(API_URLS.getRoomsLayoutData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postAddRoomLayout = (payload) =>
  customAxios
    .post(API_URLS.postAddRoomLayout, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEditRoomLayout = (query) =>
  customAxios
    .get(API_URLS.getEditRoomLayout + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const postEditRoomLayout = ({ query, data }) =>
  customAxios
    .post(API_URLS.postEditRoomLayout + query, data)
    .then((res) => res?.data)
    .catch((error) => error);

export const deleteRoomLayout = (query) =>
  customAxios
    .post(API_URLS.deleteRoomLayout, query)
    .then((res) => res?.data)
    .catch((error) => error);

// table master
export const getTableMasterData = (payload) =>
  customAxios
    .get(API_URLS.getTableMasterData)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEditTableMasterFormData = (payload) =>
  customAxios
    .get(API_URLS.getEditTableMasterFormData + payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postEditTableMasterFormData = (payload) =>
  customAxios
    .post(API_URLS.postEditTableMasterFormData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getTableMasterFormData = (payload) =>
  customAxios
    .get(API_URLS.getTableMasterFormData)
    .then((res) => res?.data)
    .catch((error) => error);

export const postAddTableMasterFormData = (payload) =>
  customAxios
    .post(API_URLS.postAddTableMasterFormData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postAddRoomInForm = (payload) =>
  customAxios
    .post(API_URLS.postAddRoomInForm, payload)
    .then((res) => res?.data)
    .catch((error) => error);

// hardware master
export const getHardwareMasterData = (payload) =>
  customAxios
    .get(API_URLS.getHardwareMasterData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postHardwareMasterData = (payload) =>
  customAxios
    .post(API_URLS.postHardwareMasterData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getHardwareMasterFormData = (payload) =>
  customAxios
    .get(API_URLS.getHardwareMasterFormData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getQualificationSelection = (payload) =>
  customAxios
    .get(API_URLS.getQualificationSelection + payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEditHardwareMasterData = (payload) =>
  customAxios
    .get(API_URLS.getEditHardwareMasterData + payload, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postEditHardwareMasterData = (payload) =>
  customAxios
    .post(API_URLS.postEditHardwareMasterData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getHardwareDetailsSession = (payload) =>
  customAxios
    .get(API_URLS.getHardwareDetailsSession, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postHardwareDetailsSession = (payload) =>
  customAxios
    .post(API_URLS.postHardwareDetailsSession, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postInventoryGeneralSettingsData = (payload) =>
  customAxios
    .post(API_URLS.postInventoryGeneralSettingsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getInventoryGeneralSettingsData = (payload) =>
  customAxios
    .get(API_URLS.getInventoryGeneralSettingsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getInventoryCountSettingsData = (payload) =>
  customAxios
    .get(API_URLS.getInventoryCountSettingsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const postAddInventoryCountSettingsData = (payload) =>
  customAxios
    .post(API_URLS.postAddInventoryCountSettingsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postGeneralCountSettings = (payload) =>
  customAxios
    .post(API_URLS.postGeneralCountSettings, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deleteInventoryCountSettingsData = (payload) =>
  customAxios
    .post(API_URLS.deleteInventoryCountSettingsData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEditInventoryCountSettingsData = (payload) =>
  customAxios
    .get(API_URLS.getEditInventoryCountSettingsData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postEditInventoryCountSettingsData = (payload) =>
  customAxios
    .post(API_URLS.postEditInventoryCountSettingsData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getLabourAddEmployeeFormData = (payload) =>
  customAxios
    .get(API_URLS.getLabourAddEmployeeFormData)
    .then((res) => res?.data)
    .catch((error) => error);

export const postLabourAddEmployeeFormData = (payload) =>
  customAxios
    .post(API_URLS.postLabourAddEmployeeFormData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getLabourEmployeeList = (payload) =>
  customAxios
    .get(API_URLS.getLabourEmployeeList, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postEditLabourEmployeeData = (payload) =>
  customAxios
    .post(
      API_URLS.postEditLabourEmployeeData +
        payload.id +
        "/" +
        payload.merchant_id,
      payload
    )
    .then((res) => res?.data)
    .catch((error) => error);

export const getEditLabourEmployeeData = (payload) =>
  customAxios
    .get(
      API_URLS.getEditLabourEmployeeData +
        payload.id +
        "/" +
        payload.merchant_id,
      payload
    )
    .then((res) => res?.data)
    .catch((error) => error);

export const getEmployeeBankingInfo = (payload) =>
  customAxios
    .get(API_URLS.getEmployeeBankingInfo, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postEmployeeBankingInfo = (payload) =>
  customAxios
    .post(API_URLS.postEmployeeBankingInfo, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deleteEmployeeBankingInfo = (payload) =>
  customAxios
    .post(API_URLS.deleteEmployeeBankingInfo, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEmployeeDocumentInfo = (payload) =>
  customAxios
    .get(API_URLS.getEmployeeDocumentInfo, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postEmployeeDocumentInfo = (payload) =>
  customAxios
    .post(API_URLS.postEmployeeDocumentInfo, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deleteEmployeeDocumentInfo = (payload) =>
  customAxios
    .post(API_URLS.deleteEmployeeDocumentInfo, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEmployeeTaxDocumentInfo = (payload) =>
  customAxios
    .get(API_URLS.getEmployeeTaxDocumentInfo, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postEmployeeTaxDocumentInfo = (payload) =>
  customAxios
    .post(API_URLS.postEmployeeTaxDocumentInfo, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deleteEmployeeTaxDocumentInfo = (payload) =>
  customAxios
    .post(API_URLS.deleteEmployeeTaxDocumentInfo, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEmployeeDependentsInfo = (payload) =>
  customAxios
    .get(API_URLS.getEmployeeDependentsInfo, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postEmployeeDependentsInfo = (payload) =>
  customAxios
    .post(API_URLS.postEmployeeDependentsInfo, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deleteEmployeeDependentsInfo = (payload) =>
  customAxios
    .post(API_URLS.deleteEmployeeDependentsInfo, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getClipBoardData = (payload) =>
  customAxios
    .get(API_URLS.getClipBoardData + payload.dayTime, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postClipBoardData = (payload) =>
  customAxios
    .post(API_URLS.postClipBoardData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postClipBoardDescription = (payload) =>
  customAxios
    .post(API_URLS.postClipBoardDescription, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deleteClipBoardDescription = (payload) =>
  customAxios
    .post(API_URLS.deleteClipBoardDescription, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPromotions = (payload) =>
  customAxios
    .post(API_URLS.getPromotions, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deletePromotion = (payload) =>
  customAxios
    .post(API_URLS.deletePromotion, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPromotionsFormData = (payload) =>
  customAxios
    .get(API_URLS.getPromotionsFormData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postAddPromotionData = (payload) =>
  customAxios
    .post(API_URLS.postAddPromotionData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postPromotionApplicationData = (payload) =>
  customAxios
    .post(API_URLS.postPromotionApplicationData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEditPromotionData = (payload) =>
  customAxios
    .get(API_URLS.getEditPromotionData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postEditPromotionData = (payload) =>
  customAxios
    .post(API_URLS.postEditPromotionData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postPromoGroup = (payload) =>
  customAxios
    .post(API_URLS.postPromoGroup, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const editPromotionPeriod = (payload) =>
  customAxios
    .post(API_URLS.editPromotionPeriod, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const addPromotionPeriod = (payload) =>
  customAxios
    .post(API_URLS.addPromotionPeriod, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getAddPromotionPeriodData = (payload) =>
  customAxios
    .get(API_URLS.getAddPromotionPeriodData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deletePromotionPeriod = (payload) =>
  customAxios
    .post(API_URLS.deletePromotionPeriod, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getQualificationCriteria = (payload) =>
  customAxios
    .get(API_URLS.getQualificationCriteria, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const postQualificationCriteria = (payload) =>
  customAxios
    .post(API_URLS.postQualificationCriteria, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getQrOrderData = (payload) =>
  customAxios
    .get(API_URLS.getQrOrderData, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const postQrOrderData = (payload) =>
  customAxios
    .post(API_URLS.postQrOrderData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postPdfMenu = (payload) =>
  customAxios
    .post(API_URLS.postPdfMenu, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const editPostPdfMenuData = (payload) =>
  customAxios
    .post(API_URLS.editPostPdfMenuData + payload?.id, payload?.submitData)
    .then((res) => res?.data)
    .catch((error) => error);

export const getMenuSequencingData = (payload) =>
  customAxios
    .get(API_URLS.getMenuSequencingData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postMenuSequencingData = (payload) =>
  customAxios
    .post(API_URLS.postMenuSequencingData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getQrList = (payload) =>
  customAxios
    .get(API_URLS.getQrList, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const downloadQrList = (payload) =>
  customAxios
    .get(API_URLS.downloadQrList, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const downloadSelectedQr = (payload) =>
  customAxios
    .post(API_URLS.downloadSelectedQr, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const regenerateSelectedQr = (payload) =>
  customAxios
    .post(API_URLS.regenerateSelectedQr, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const refreshTableQrCode = (payload) =>
  customAxios
    .post(API_URLS.refreshTableQrCode, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getOrdrrOnlineMenuSequencingData = (payload) =>
  customAxios
    .get(API_URLS.getOrdrrOnlineMenuSequencingData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postOrdrrOnlineMenuSequencingData = (payload) =>
  customAxios
    .post(API_URLS.postOrdrrOnlineMenuSequencingData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

// ordrr online
export const getOrdrrOnlineData = (payload) =>
  customAxios
    .get(API_URLS.getOrdrrOnlineData, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const postOrdrrOnlineData = (payload) =>
  customAxios
    .post(API_URLS.postOrdrrOnlineData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getDeliveryPartnerData = (payload) =>
  customAxios
    .get(API_URLS.getDeliveryPartnerData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postDeliveryPartnerData = (payload) =>
  customAxios
    .post(API_URLS.postDeliveryPartnerData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const addDeliveryPartner = (payload) =>
  customAxios
    .post(API_URLS.addDeliveryPartner, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const editDeliveryPartner = (payload) =>
  customAxios
    .post(API_URLS.editDeliveryPartner + payload?.id, payload?.submitData)
    .then((res) => res?.data)
    .catch((error) => error);

export const deleteDeliveryPartner = (payload) =>
  customAxios
    .post(API_URLS.deleteDeliveryPartner, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getApiKeyListing = (payload) =>
  customAxios
    .get(API_URLS.getApiKeyListing, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postConfirmPassword = (payload) =>
  customAxios
    .post(API_URLS.postConfirmPassword, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postDeleteApiKey = (payload) =>
  customAxios
    .post(API_URLS.postDeleteApiKey, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postGenerateApiKey = (payload) =>
  customAxios
    .post(API_URLS.postGenerateApiKey, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getIntegrationData = (payload) =>
  customAxios
    .get(API_URLS.getIntegrationData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postPackageStatus = (payload) =>
  customAxios
    .post(API_URLS.postPackageStatus, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getIntegrationEditData = (payload) =>
  customAxios
    .get(API_URLS.getIntegrationEditData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postIntegrationEditData = (payload) =>
  customAxios
    .post(API_URLS.postIntegrationEditData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postPauseStore = (payload) =>
  customAxios
    .post(API_URLS.postPauseStore, payload)
    .then((res) => res?.data)
    .catch((error) => error);

// eslint-disable-next-line import/no-anonymous-default-export

export default {
  postPauseStore,
  postIntegrationEditData,
  getIntegrationEditData,
  postPackageStatus,
  getIntegrationData,
  postGenerateApiKey,
  postDeleteApiKey,
  postConfirmPassword,
  getApiKeyListing,
  deleteDeliveryPartner,
  editDeliveryPartner,
  addDeliveryPartner,
  getDeliveryPartnerData,
  postDeliveryPartnerData,
  getOrdrrOnlineData,
  postOrdrrOnlineData,
  postOrdrrOnlineMenuSequencingData,
  getOrdrrOnlineMenuSequencingData,
  refreshTableQrCode,
  regenerateSelectedQr,
  downloadQrList,
  downloadSelectedQr,
  getQrList,
  getMenuSequencingData,
  postMenuSequencingData,
  postPdfMenu,
  editPostPdfMenuData,
  getQrOrderData,
  postQrOrderData,
  getAddPromotionPeriodData,
  postQualificationCriteria,
  getQualificationCriteria,
  deletePromotionPeriod,
  editPromotionPeriod,
  addPromotionPeriod,
  postPromoGroup,
  postEditPromotionData,
  getEditPromotionData,
  postPromotionApplicationData,
  postAddPromotionData,
  getPromotionsFormData,
  deletePromotion,
  getPromotions,
  deleteClipBoardDescription,
  postClipBoardDescription,
  postClipBoardData,
  getClipBoardData,
  getEmployeeDependentsInfo,
  postEmployeeDependentsInfo,
  deleteEmployeeDependentsInfo,
  getEmployeeTaxDocumentInfo,
  postEmployeeTaxDocumentInfo,
  deleteEmployeeTaxDocumentInfo,
  deleteEmployeeDocumentInfo,
  postEmployeeDocumentInfo,
  getEmployeeDocumentInfo,
  deleteEmployeeBankingInfo,
  postEmployeeBankingInfo,
  getEmployeeBankingInfo,
  postEditLabourEmployeeData,
  getEditLabourEmployeeData,
  getLabourEmployeeList,
  postLabourAddEmployeeFormData,
  getLabourAddEmployeeFormData,
  getEditInventoryCountSettingsData,
  postEditInventoryCountSettingsData,
  deleteInventoryCountSettingsData,
  postGeneralCountSettings,
  postAddInventoryCountSettingsData,
  getInventoryCountSettingsData,
  getInventoryGeneralSettingsData,
  postInventoryGeneralSettingsData,
  postHardwareDetailsSession,
  getHardwareDetailsSession,
  postEditHardwareMasterData,
  getEditHardwareMasterData,
  postHardwareMasterData,
  getQualificationSelection,
  getHardwareMasterFormData,
  getHardwareMasterData,
  postAddRoomInForm,
  postAddTableMasterFormData,
  getTableMasterFormData,
  postEditTableMasterFormData,
  getEditTableMasterFormData,
  getTableMasterData,
  deleteRoomLayout,
  getEditRoomLayout,
  postEditRoomLayout,
  postAddRoomLayout,
  getRoomsLayoutData,
  getFrequency,
  getApplicableModule,
  // getPosIntegrationSettingData,
  postPosIntegrationSetting,
  postEditPosMasterFormData,
  getEditPosMasterFormData,
  getPosMasterFormOptions,
  postPosMasterActiveStatus,
  getPosMasterData,
  postAddPosMasterFormData,
  deleteCompetitorOnlifeData,
  postCompetitorOnlifeData,
  postMerchantOnlifeData,
  getOnlifeData,
  updateTransferAccountStatus,
  editTransferAccount,
  postOrderTransferData,
  getAccountSetting,
  saveUploadAccLogo,
  getCompanySetting,
  saveUploadAccDocument,
  deleteAccountingDocument,
  updateAccPeriodStatus,
  saveScheduleCompanyName,
  getScheduleCompanyName,
  getCodeList,
  saveCodeData,
  deleteCodeDetails,
  getAccountManagement,
  saveAccountManagementData,
  updateAccountAdminData,
  updatePlanCostData,
  updatePlanTopupData,
  updatePosCountData,
  savePaymentInfoData,
  getOwnerSubAccData,
  cancelAccountData,
  getInvoiceListData,
  getInvoiceDetailsData,
  getUserManagementData,
  getMerchantUserListData,
  updateUserManageData,
  addLinkedEmployeeData,
  getPermissionGroupListData,
  getClusterSetting,
  addClusterDetails,
  saveClusterdetails,
  editClusterdetails,
  getClusterModules,
  addClusterAccess,
  editClusterAccess,
  addClusterStore,
  getFinanceGeneralDetails,
  saveFinanceGeneralDetails,
  getFinanceSaleDetails,
  getOrderSettings,
  postOrderSettings,
  savePaymentMethodDetails,
  updatePaymentMethodDetails,
  udpatePaymentMethodOrder,
  deletePaymentMethodDetails,
  getGroupAccDetails,
  saveServicePeriodDetails,
  updateServicePeriodDetails,
  deleteServicePeriodDetails,
  saveSaleTypeDetails,
  updateSaleTypeDetails,
  deleteSaleTypeDetails,
  saveSaleGroupDetails,
  deleteSaleGroupDetails,
  saveChannelDetails,
  updateChannelDetails,
  deleteChannelDetails,
  getPublicHolidayDetails,
  savePublicHolidayDetails,
  deletePublicHolidayDetails,
  updateMatrixSetting,
  getMasterSettingDetails,
  getFinanceChartOfAccSettingDetails,
  getFinanceAccDetails,
  savePmMasterSettingDetails,
  updatePmMasterSettingDetails,
  updatePmMasterSettingStatusDetails,
  refreshPmMasterSettingDetails,
  saveSalesMasterSettingDetails,
  updateSalesMasterSettingDetails,
  updateSalesMasterSettingStatusDetails,
  refreshSalesMasterSettingDetails,
  saveServicePeriodsMasterSettingDetails,
  updateServicePeriodsMasterSettingDetails,
  updateServicePeriodsMasterSettingStatusDetails,
  refreshServicePeriodsMasterSettingDetails,
  saveChannelsMasterSettingDetails,
  updateChannelsMasterSettingDetails,
  updateChannelsMasterSettingStatusDetails,
  refreshChannelsMasterSettingDetails,
  downloadAllFinanceAccDetail,
  addFinanceAccDetail,
  addFinanceSubAccDetail,
  saveFinanceSubAccDetail,
  saveEditSubAccDetail,
  saveAccTransaction,
  getUpdateFinanceSubAccDetail,
  getSubAccTransactionsDetails,
  getOrderTransferData,
  getSecondAccounts,
  addTransferAccount,
  getTransferAccountEditDetails,
  getAddTransSubAccDetail,
  getDebitCreditAccDetails,
  getForecastSettingsDetail,
  getForecastRulesDetail,
  getApplicableQuarterDetail,
  saveForecastSettingsDetail,
  editFinanceRuleDetail,
  updateFinanceRuleDetail,
  getReconsileDetail,
  saveReconsileDetail,
  deleteReconsileDetail,
  getReconsileUploadDetail,
  saveReconsileUploadDetail,
};
